import { useEffect } from 'react';
import { string, func, arrayOf } from 'prop-types';
import { useProductDeprecated, useFBTDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useFallback } from '../../hooks/useFallback';

const DynamicRecsLoader = ({
  itemId, storeId: propStoreId, children, onChange
}) => {

  const storeId = propStoreId || useStoreId({ varnish: true, online: false });

  const bundleResponse = useFBTDeprecated({
    itemId,
    storeId,
    productDomains: ['identifiers', 'info', 'media', 'pricing', 'reviews', 'details'],
    ssr: true
  });

  const domains = ['identifiers', 'info', 'media', 'pricing', 'reviews'];
  const productResponse = useProductDeprecated({ itemId, storeId, domains });

  const bundleProducts = bundleResponse?.data?.bundle?.products;
  const skip = storeId === '8119' || !!(bundleProducts && bundleProducts.length !== 0);

  // fallback to FBT if bundle product is OOS
  const fbtResponse = useFallback({
    itemId,
    storeId,
    skip
  });

  let dynamicRecsResponse = bundleResponse;
  if (fbtResponse && fbtResponse.data) {
    dynamicRecsResponse = fbtResponse;
  }

  useEffect(() => {
    if (onChange) {
      onChange(dynamicRecsResponse);
    }
  }, [itemId, dynamicRecsResponse.data]);

  let loadedStoreId = storeId;
  if (dynamicRecsResponse.data && !dynamicRecsResponse.loading && dynamicRecsResponse.called) {
    loadedStoreId = dynamicRecsResponse.variables.storeId;
  }

  return children(dynamicRecsResponse, loadedStoreId, productResponse);
};

DynamicRecsLoader.propTypes = {
  itemId: string.isRequired,
  storeId: string,
  domains: arrayOf(string),
  onChange: func,
  children: func
};

export default DynamicRecsLoader;
